import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import TranslateIcon from 'assets/images/shell/icon-translate.svg'
import BellIcon from 'assets/images/shell/icon-bell.svg'
import CaretIcon from 'assets/images/shell/icon-caret.svg'

import './Header.scss'

function Header({ logoutHandler }) {
  const { pathname } = useLocation()
  const [menuOpen, setMenuOpen] = useState(false)
  const rawUserInfo = localStorage.getItem('uuInfo')
  let userInfo = {}
  try {
    userInfo = rawUserInfo ? JSON.parse(rawUserInfo) : {}
  } catch (error) {
    userInfo = {}
  }

  const userName = userInfo?.name || userInfo?.fullName || 'Al Asrar'
  const userRole = userInfo?.role || 'Admin'
  const initials = String(userName)
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() || '')
    .join('')
    .slice(0, 2)

  const pathSegments = pathname.split('/').filter(Boolean)
  const rootSegment = pathSegments[0] || 'dashboard'

  const titleMap = {
    home: 'Dashboard',
    dashboard: 'Dashboard',
    events: 'Events',
    users: 'Users Listing',
    notifications: 'Notification Listing',
    teams: 'Teams Listing',
    organizations: 'Organizations Listing',
    attendances: 'Attendances',
    eventsattended: 'Events Attended',
  }

  const headerTitle =
    titleMap[rootSegment] ||
    rootSegment
      .replace(/-/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase())

  return (
    <div className='header-main'>
      <div className='container-fluid'>
        <div className='wrapper'>
          <div className='header-title'>{headerTitle}</div>

          <div className='header-actions'>
            <button type='button' className='header-icon-btn' aria-label='Language'>
              <img src={TranslateIcon} width={24} height={24} alt='' />
            </button>

            <button
              type='button'
              className='header-icon-btn header-icon-btn--notification'
              aria-label='Notifications'
            >
              <img src={BellIcon} width={24} height={24} alt='' />
              <span className='notification-badge'>4</span>
            </button>

            <div className='profile-otr'>
              <div className='avatar'>{initials || 'AA'}</div>
              <div className='profile-text'>
                <p className='user-name'>{userName}</p>
                <p className='user-role'>{userRole}</p>
              </div>
              <button
                type='button'
                className='profile-caret'
                aria-label='Account menu'
                onClick={() => setMenuOpen((open) => !open)}
              >
                <img src={CaretIcon} width={34} height={34} alt='' />
              </button>
              {menuOpen && (
                <button
                  type='button'
                  className='profile-logout'
                  onClick={logoutHandler}
                >
                  Logout
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Header.propTypes = {
  logoutHandler: PropTypes.func.isRequired,
}

export default Header
